import { array, boolean, number, object, type output, string } from 'zod/v4'

export const TrialOverridesTypeValidator = object({
  hideUgcSection: boolean(),
  measurementsSummary: string(),
  siteInfo: object({
    principalInvestigator: string(),
    protocolNumber: string(),
    siteName: string(),
  }),
  timeline: object({
    // Stringified Markdown
    additionalInfo: string().optional(),
    screeningDuration: string().optional(),
  }),
  treatmentData: array(
    object({
      drug: object({
        approved: boolean(),
        name: string(),
        simpleDescription: string(),
      }),
      intervention: object({
        firstStudied: string(),
        latestPhase: object({
          description: string(),
          label: string(),
        }),
        name: string(),
        patientsTreated: number(),
      }),
    }),
  ),
  trialDesign: object({
    enrollmentSummary: string().optional(),
  }),
}).partial()

export type TrialOverrides = output<typeof TrialOverridesTypeValidator>
